<style>
@import './assets/styles/w3.css';
@import './assets/styles/fontawesome.min.css';
@import './assets/styles/rc_main.css';
@import './assets/styles/rc_box.css';
@import './assets/styles/rc_text.css';
@import './assets/styles/rc_input.css';
@import './assets/styles/rc_font.css';
@import './v3/assets/styles/rc_cards.css';
@import './v3/assets/styles/rc_dialog_form.css';

/* A v-alert is a two-row grid: the message spans both rows, but the icon sits in the first only
   and is pinned to its top, so once the buttons make the message taller the icon rides high. */
.rc-action-banner .v-alert__prepend {
  grid-row: 1 / -1;
  align-self: center;
}
</style>
<template>
  <v-app v-if="userRoles.isAdmin">
    <AppAIChatSidebar v-model="isSidebarOpen" @closeDialog="setSidebarOpen(false)" />
    <div v-if="userRoles.isV3">
      <AppHeaderV3 :userInfo="userInfo" :companyInfo="companyInfo" :divisions="divisionList" @navigate="onNavigate"
        @toggleSidebar="handleSidebarToggle" @divisionChanged="handleDivisionChanged"
        @groupChanged="handleGroupChanged" />
      <AppSidebarV3 :is-collapsed="isSidebarCollapsed" :is-owner-or-manager="false" :is-mechanic="false"
        :is-admin="true" :is-local-dev="userRoles.isV3" :features="companyFeatures" @navigate="onNavigate"
        @toggleSidebar="handleSidebarToggle" />
      <v-main>
        <v-alert v-if="(isMissingAddresses || isMissingBilling) && !userRoles.isAdmin" type="warning" variant="tonal"
          density="compact" class="rc-action-banner ma-2" border="start">
          <div class="d-flex align-center justify-space-between flex-wrap">
            <div class="mr-2 mb-1 mb-sm-0">
              <strong class="me-1">{{ $t('shell_banner_action_required') }}</strong>
              <span v-if="isMissingAddresses && isMissingBilling" class="text-sm">{{ $t('shell_banner_missing_both') }}</span>
              <span v-else-if="isMissingAddresses" class="text-sm">{{ $t('shell_banner_missing_addresses') }}</span>
              <span v-else-if="isMissingBilling" class="text-sm">{{ $t('shell_banner_missing_billing') }}</span>
            </div>
            <div class="d-flex ga-2">
              <v-btn v-if="isMissingAddresses" color="warning" variant="elevated" size="small"
                @click="onNavigate({ value: 'company/display', content: 'company', version: 'v3' })">
              {{ $t('shell_banner_company_settings') }}
              </v-btn>
              <v-btn v-if="isMissingBilling" color="warning" variant="elevated" size="small"
                @click="onNavigate({ value: 'billing/display', content: 'company', version: 'v3' })">
              {{ $t('shell_banner_billing_settings') }}
              </v-btn>
            </div>
          </div>
        </v-alert>
        <div>
          <router-view />
        </div>
      </v-main>
      <AppFooterV3 :user="auth_user" :client="auth_client" />
    </div>
    <v-main v-else>
      <AppAIChatSidebar v-model="isSidebarOpen" @closeDialog="setSidebarOpen(false)" />
      <v-row>
        <v-col :cols="12">
          <app-header />
        </v-col>
      </v-row>
      <v-row v-if="isAdmin">
        <v-col :cols="1">
          <div>
            &nbsp;&nbsp;&nbsp;&nbsp;<router-link to="/portal/admin/company/list"
              class="rc-text-small rc-padding-normal rc-border-round" onclick="w3_close()">Companies</router-link><br>
            &nbsp;&nbsp;&nbsp;&nbsp;<router-link to="/portal/admin/invoice/list"
              class="rc-text-small rc-padding-normal rc-border-round" onclick="w3_close()">Invoices</router-link><br>
            &nbsp;&nbsp;&nbsp;&nbsp;<router-link to="/portal/admin/registration/list"
              class="rc-text-small rc-padding-normal rc-border-round"
              onclick="w3_close()">Registrations</router-link><br>
            &nbsp;&nbsp;&nbsp;&nbsp;<router-link to="/portal/admin/vehicle/list"
              class="rc-text-small rc-padding-normal rc-border-round" onclick="w3_close()">Vehicles</router-link><br>
            &nbsp;&nbsp;&nbsp;&nbsp;<router-link to="/portal/admin/user/list"
              class="rc-text-small rc-padding-normal rc-border-round" onclick="w3_close()">Users</router-link><br>
            &nbsp;&nbsp;&nbsp;&nbsp;<router-link to="/portal/admin/inspection/list"
              class="rc-text-small rc-padding-normal rc-border-round" onclick="w3_close()">Inspections</router-link><br>
            &nbsp;&nbsp;&nbsp;&nbsp;<router-link to="/portal/admin/hour/list"
              class="rc-text-small rc-padding-normal rc-border-round" onclick="w3_close()">Hours</router-link><br>
            &nbsp;&nbsp;&nbsp;&nbsp;<router-link to="/portal/admin/checklist/list"
              class="rc-text-small rc-padding-normal rc-border-round" onclick="w3_close()">Checklists</router-link><br>
            &nbsp;&nbsp;&nbsp;&nbsp;<router-link to="/portal/admin/report/list"
              class="rc-text-small rc-padding-normal rc-border-round" onclick="w3_close()">Reports</router-link><br>
            &nbsp;&nbsp;&nbsp;&nbsp;<router-link to="/portal/admin/equipment/list"
              class="rc-text-small rc-padding-normal rc-border-round" onclick="w3_close()">Equipment</router-link><br>
            &nbsp;&nbsp;&nbsp;&nbsp;<router-link to="/portal/admin/schedule/list"
              class="rc-text-small rc-padding-normal rc-border-round" onclick="w3_close()">Schedules</router-link><br>
            &nbsp;&nbsp;&nbsp;&nbsp;<router-link to="/portal/admin/card/list"
              class="rc-text-small rc-padding-normal rc-border-round" onclick="w3_close()">Cards</router-link><br>
            &nbsp;&nbsp;&nbsp;&nbsp;<router-link to="/portal/admin/map/list"
              class="rc-text-small rc-padding-normal rc-border-round" onclick="w3_close()">Map</router-link><br>
            &nbsp;&nbsp;&nbsp;&nbsp;<router-link to="/portal/admin/whatsnew"
              class="rc-text-small rc-padding-normal rc-border-round" onclick="w3_close()">Whats New</router-link><br>
            &nbsp;&nbsp;&nbsp;&nbsp;<router-link to="/portal/admin/dashboard"
              class="rc-text-small rc-padding-normal rc-border-round" onclick="w3_close()">Dashboard</router-link><br>
            &nbsp;&nbsp;&nbsp;&nbsp;<router-link to="/portal/admin/stats"
              class="rc-text-small rc-padding-normal rc-border-round" onclick="w3_close()">Stats</router-link><br>
            &nbsp;&nbsp;&nbsp;&nbsp;<router-link to="/portal/admin/blank"
              class="rc-text-small rc-padding-normal rc-border-round" onclick="w3_close()">Blank</router-link><br>
          </div>
        </v-col>

        <v-col :showBorder="false" :cols="10" :offset="0">
          <v-row>
            <v-col>
              <router-view />
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row v-else>
        <v-col :showBorder="false" :cols="10" :offset="1">
          <v-row>
            <v-col>
              <router-view />
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col :cols="10" offset="1">
          <app-footer />
        </v-col>
      </v-row>

    </v-main>
    <AppUpdateNotice :model-value="updateAvailable" @refresh="reloadPage" />
  </v-app>
  <v-app v-else-if="!userRoles.isV3">
    <AppAIChatSidebar v-model="isSidebarOpen" @closeDialog="setSidebarOpen(false)" />
    <v-main>
      <v-row>
        <v-col :cols="12">
          <app-header />
        </v-col>
      </v-row>

      <v-row>
        <v-col :showBorder="false" :cols="10" :offset="1">
          <v-row>
            <v-col>
              <router-view />
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col :cols="10" offset="1">
          <app-footer />
        </v-col>
      </v-row>

    </v-main>
    <AppUpdateNotice :model-value="updateAvailable" @refresh="reloadPage" />
  </v-app>
  <v-app v-else>
    <AppAIChatSidebar v-model="isSidebarOpen" @closeDialog="setSidebarOpen(false)" />

    <!-- Not in a page framed by another site (?embed=1, e.g. /pricing on readychek.com). -->
    <div v-if="!showAuthenticatedLayout && route.query.embed !== '1' && enableLanguage"
      :style="{ position: 'fixed', top: '20px', right: enableAiChat ? '80px' : '16px', zIndex: 100 }">
      <RcLanguageMenu />
    </div>
    <v-btn v-if="!showAuthenticatedLayout && enableAiChat && route.query.embed !== '1'" icon="mdi-help-circle-outline" variant="text" color="primary"
      size="x-large" @click="setSidebarOpen(true)"
      style="position: fixed; top: 16px; right: 16px; z-index: 100;"></v-btn>
    <AppHeaderV3 v-if="showAuthenticatedLayout" :userInfo="userInfo" :companyInfo="companyInfo"
      :divisions="divisionList" @navigate="onNavigate" @toggleSidebar="handleSidebarToggle"
      @divisionChanged="handleDivisionChanged" @groupChanged="handleGroupChanged" />
    <AppSidebarV3 v-if="showAuthenticatedLayout" :is-collapsed="isSidebarCollapsed" :is-mechanic="userRoles.isMechanic"
      :is-owner-or-manager="userRoles.isOwnerOrManager" :is-admin="userRoles.isAdmin" :is-local-dev="userRoles.isV3"
      :features="companyFeatures" @navigate="onNavigate" @toggleSidebar="handleSidebarToggle" />
    <v-main>
      <v-alert v-if="isMissingAddresses || isMissingBilling" type="warning" variant="tonal" class="rc-action-banner ma-4"
        density="compact" border="start">
        <div class="d-flex align-center justify-space-between flex-wrap">
          <div class="mr-2 mb-1 mb-sm-0">
            <strong class="me-1">{{ $t('shell_banner_action_required') }}</strong>
            <span v-if="isMissingAddresses && isMissingBilling">{{ $t('shell_banner_missing_both') }}</span>
            <span v-else-if="isMissingAddresses">{{ $t('shell_banner_missing_addresses') }}</span>
            <span v-else-if="isMissingBilling">{{ $t('shell_banner_missing_billing') }}</span>
          </div>
          <div class="d-flex ga-2">
            <v-btn v-if="isMissingAddresses" color="warning" variant="elevated" size="small"
              @click="onNavigate({ value: 'company/display', content: 'company', version: 'v3' })">
              {{ $t('shell_banner_company_settings') }}
            </v-btn>
            <v-btn v-if="isMissingBilling" color="warning" variant="elevated" size="small"
              @click="onNavigate({ value: 'billing/display', content: 'company', version: 'v3' })">
              {{ $t('shell_banner_billing_settings') }}
            </v-btn>
          </div>
        </div>
      </v-alert>
      <div>
        <router-view />
      </div>
    </v-main>
    <AppFooterV3 v-if="showAuthenticatedLayout" :user="auth_user" :client="auth_client" />
    <AppUpdateNotice :model-value="updateAvailable" @refresh="reloadPage" />
  </v-app>
</template>
<script>
import AppFooter from '@/views/app/AppFooter.vue';
import AppHeader from '@/views/app/AppHeader.vue';
import { onMounted } from 'vue';
import { useTheme } from 'vuetify';
import { mapGetters } from 'vuex';
import BooleanUtils from './utils/BooleanUtils';

export default {
  name: 'app',
  components: {
    AppHeader,
    AppFooter,
  },
  data() {
    return {
      error: null,
      isAdmin: false,
    };
  },
  computed: {
    ...mapGetters([
      'auth_user',
      'auth_client',
      'roles_found',
      'user_role',
      'AuthStorage_Company',
      'domain',
    ]),
  },
  watch: {
    AuthStorage_Company() {
      if (!this.domain) {
        this.isAdmin = false;
      } else {
        this.isAdmin = this.domain.session().employee().find().roles().find().isAdministrator();
      }
    },
  },
  methods: {},

};
</script>

<script setup>
import { useHead } from '@vueuse/head';
import AppFooterV3 from '@/v3/app/AppFooter.vue';
import AppHeaderV3 from '@/v3/app/AppHeader.vue';
import AppSidebarV3 from '@/v3/app/AppSidebar.vue';
import AppAIChatSidebar from "@/v3/app/AppAIChatSidebar.vue";
import AppUpdateNotice from '@/v3/app/AppUpdateNotice.vue';
import RcLanguageMenu from '@/v3/components/library/language/RcLanguageMenu.vue';
import { useAiContext } from '@/v3/composables/useAiContext';
import { useCompany } from '@/v3/composables/useCompany';
import { useTextSize } from '@/v3/composables/useTextSize';
import { computed, markRaw, ref, watch, onUnmounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useDisplay } from 'vuetify';
import { useStore } from 'vuex';
import StringUtils from './utils/StringUtils';
import LocalStorageUtils from './utils/LocalStorageUtils';
import { useConnection } from './v3/composables/useConnection';
import { t } from '@/i18n/index.js';

const router = useRouter();
const route = useRoute();
const store = useStore();
const { mobile } = useDisplay();
const { isSidebarOpen, setSidebarOpen, enableAiChat } = useAiContext();
const enableLanguage = computed(() => false);

const domain = computed(() => store.getters.domain);
const auth_user = computed(() => store.getters.auth_user);
const auth_client = computed(() => store.getters.auth_client);

useHead({
  titleTemplate: (title) => title ? `${title} - ReadyChek` : t('shell_app_title'),
  title: '',
  meta: [
    { name: 'description', content: 'ReadyChek is a revolution in commercial vehicle pre trip inspection reporting and hours of service, with an easy to use layout that will have you on the road quickly and not sitting in the yard filling out paperwork. Let ReadyChek manage all of your commercial vehicle inspection records for every vehicle in your fleet (MTO & NSC). No more filing cabinets or boxes full of vehicle inspection reports, and no more lost papers or inspection books.' },
    { name: 'keywords', content: 'commercial vehicle inspections, pre trip inspection reporting, hours of service, log book, compliance, MTO, NSC, fleet management' },
    { property: 'og:title', content: 'ReadyChek - Pre Trip Inspections, Log Book & Compliance' },
    { property: 'og:description', content: 'ReadyChek is a revolution in commercial vehicle pre trip inspection reporting and hours of service, with an easy to use layout that will have you on the road quickly and not sitting in the yard filling out paperwork. Let ReadyChek manage all of your commercial vehicle inspection records for every vehicle in your fleet (MTO & NSC). No more filing cabinets or boxes full of vehicle inspection reports, and no more lost papers or inspection books.' },
    { property: 'og:image', content: 'https://static.wixstatic.com/media/b0f7fd_8ac1016b1ecc404bae1a247ef463f3cc~mv2.png/v1/fill/w_306,h_70,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/ReadyChek%20Logo.png' },
    { property: 'og:type', content: 'website' },
    { property: 'og:url', content: 'https://readychek.app/' },
    { name: 'twitter:card', content: 'summary_large_image' },
  ]
});

const {
  log,
} = useConnection(domain);

const savedSidebarState = localStorage.getItem('rc-sidebar-collapsed');
const isSidebarCollapsed = ref(savedSidebarState !== null ? savedSidebarState === 'true' : (mobile ? true : false));
const showAuthenticatedLayout = ref(false);
const { loadCompanyDivisions, loadedCompanyList } = useCompany(domain);

const isMissingAddresses = computed(() => {
  if (!domain.value || !domain.value.session() || !showAuthenticatedLayout.value) return false;
  const company = domain.value.session().company();
  if (!company || company.isNew()) return false;

  const address = company.address().find();
  const hqAddress = company.addressHq().find();

  if (!address || !hqAddress) return true;

  const isAddressMissing = !address.street() || !address.city();
  const isHqMissing = !hqAddress.street() || !hqAddress.city();

  return isAddressMissing || isHqMissing;
});

const isMissingBilling = computed(() => {
  if (!domain.value || !domain.value.session() || !showAuthenticatedLayout.value) return false;
  const company = domain.value.session().company();
  if (!company || company.isNew()) return false;

  const contractStart = company.contractStartDate();
  const now = domain.value.session().time().now();
  const diffMs = now.diff(contractStart);
  const daysUntil = diffMs / (1000 * 60 * 60 * 24);

  if (daysUntil > 5) return false;
  if (daysUntil < -15) return false;

  const settings = company.invoiceSettings().find();
  if (!settings) return true;

  const isInvoiceMissing = !settings.companyName() || !settings.contactName() || !settings.contactEmail();

  const isCardRequired = company.isPaymentMethodCreditCard();
  const isCardMissing = isCardRequired && !company.hasCard();

  return isInvoiceMissing || isCardMissing;
});


const handleSidebarToggle = () => {
  isSidebarCollapsed.value = !isSidebarCollapsed.value;
  localStorage.setItem('rc-sidebar-collapsed', isSidebarCollapsed.value);
};

const handleDivisionChanged = (divisionId) => {
  log.info("Division Changed: {0} route {1}", [divisionId, route.query]);

  const current = LocalStorageUtils.getReadyChek();
  const globalFilters = current.globalFilters || {};
  globalFilters['division'] = divisionId;
  LocalStorageUtils.setReadyChek({ globalFilters });

  store.dispatch('AuthStorage_updateDivisionLabel', divisionId);
};

const handleGroupChanged = (groupId) => {
  log.info("Location Changed: {0}", [groupId]);
  const current = LocalStorageUtils.getReadyChek();
  const globalFilters = current.globalFilters || {};
  globalFilters['location'] = groupId;
  LocalStorageUtils.setReadyChek({ globalFilters });

  store.dispatch('AuthStorage_updateGroupLabel', groupId);
}

const userRoles = computed(() => {
  let defaultValue = true;
  const v3 = BooleanUtils.toBoolean(window?.localStorage["v3"] ?? defaultValue);
  if (!domain.value || !domain.value.session()) {
    return { isMechanic: false, isAdmin: false, isV3: v3, isOwnerOrManager: false };
  }
  const employee = domain.value.session().employee();
  const roles = employee ? employee.roles().find() : null;
  return {
    isMechanic: roles ? roles.isMechanic() : false,
    isAdmin: roles ? roles.isAdministrator() : false,
    isOwnerOrManager: roles ? roles.isOwnerOrManager() : false,
    isV3: v3,
  };
});

const companyFeatures = computed(() => {
  if (!domain.value || !domain.value.session()) {
    return {};
  }
  const features = domain.value.session().company().features().find();
  if (!features) return {};

  return {
    inspections: features.allowsInspections(),
    timesheets: features.allowsTimesheets(),
    checklists: features.allowsVehicles(),
    map: features.allowsMap(),
    vehicles: features.allowsVehicles(),
    equipment: features.allowsEquipment(),
    tracking: features.allowsTrackLocation(),
    compliance: features.allowsCompliance(),
    gpsDevice: features.allowsGpsDevice(),
  };
});

const divisionList = computed(() => {
  var list = [];
  for (var index in loadedCompanyList.value) {
    let division = loadedCompanyList.value[index];
    list.push({ name: division.name(), id: division.id(), address: division.address().find().location(), encodedId: division.idEncoded() });
  }
  return list;
});

const companyInfo = computed(() => {
  if (!domain.value || !domain.value.session()) {
    return { name: 'ReadyChek', idEncoded: null, hasMultiple: false, divisionPath: [] };
  }
  const session = domain.value.session();
  const company = session.company();
  const employee = session.employee();
  let path = [];
  let temp = company;
  while (temp && temp.isNotNew()) {
    let list = temp.divisions().sortByName();
    let _name = temp.divisionName();
    path.unshift({
      id: temp.id(),
      idEncoded: temp.idEncoded(),
      name: _name,
      isDivision: temp.isDivision(),
      divisions: markRaw(list),
      parentName: temp.isDivision() ? temp.name() : null,
      locations: temp.labels().data
    });
    if (temp.isDivision()) {
      temp = temp.parent().find();
      if (temp.id() !== employee.company().id()) {
        temp = null;
      }
    } else {
      temp = null;
    }
  }
  if (temp && temp.isNew()) {
    path.unshift({
      id: temp.id(),
      idEncoded: temp.idEncoded(),
      name: temp.name(),
      isDivision: false,
      divisions: [],
      locations: temp.labels().data
    });
  }

  const user = session.user();
  const employees = user ? domain.value.employees().findByUserId(user.id()).list() : [];
  const _name = company ? company.name() : 'ReadyChek';
  const map = {
    name: _name,
    divisionPath: path,
    currentCompany: company.id(),
    idEncoded: company ? company.idEncoded() : null,
    hasMultiple: employees.length > 1,
  };
  return map;
});

const userInfo = computed(() => {
  if (!domain.value || !domain.value.session()) {
    return { firstName: t('shell_guest'), idEncoded: null };
  }
  const user = domain.value.session().user();
  return {
    firstName: user ? user.firstDisplay() : t('shell_guest'),
    idEncoded: user ? user.idEncoded() : null,
  };
});

const AuthStorage_Company = computed(() => store.getters.AuthStorage_Company);
watch(AuthStorage_Company, (newCompany) => {
  let hasCompany = true;
  if (!newCompany) {
    hasCompany = false;
  }
  const isNewCompany = newCompany ? newCompany.isNew() : false;
  showAuthenticatedLayout.value = hasCompany && !isNewCompany;

  if (newCompany != null && newCompany.isNotNew()) {
    if (newCompany.hasFeatureDivisions()) {
      loadCompanyDivisions(newCompany, {})
    }
  }
},
  { immediate: true }
);

const onNavigate = (path) => {
  if (!domain.value || !domain.value.session()) {
    console.error("Cannot navigate: domain or session not available.");
    return;
  }
  let rolePath = 'operator';
  let company = domain.value.session().company();
  let pathValue = path.value;
  let content = path.content;
  let companyId = '';
  let subPath = '';

  if (content === "company" || content === "" || content == undefined) {
    rolePath = "operator/";
    companyId = company.idEncoded();
    if (company.isNew()) {
      return;
    }
    subPath = `${rolePath}${companyId}/${pathValue}`;

  } else if (pathValue.startsWith("accounts/:operatorId")) {
    companyId = company.idEncoded();
    if (company.isNew()) {
      return;
    }
    rolePath = "admin/";
    subPath = `${rolePath}${StringUtils.replace(pathValue, ":operatorId", companyId)}`;

  } else {
    rolePath = "admin";
    pathValue = `${pathValue}`;
    subPath = `${rolePath}/${pathValue}`;
  }

  let newPath = `/portal/v3/${subPath}`;
  if (path['version'] == null || path.version == '') {
    if (path['version'] == null) {
      newPath = `/portal/${rolePath}/${companyId}/${path}`;
    } else {
      newPath = `/portal/${rolePath}/${companyId}/${path.value}`;
    }
  }
  console.log('Navigating to:', newPath);
  router.push({ path: newPath });
};

const theme = useTheme();

const updateAvailable = ref(false);
let lastCheckTime = Date.now();
let updateInterval = null;

const checkUpdate = async () => {
  try {
    const res = await fetch('/version.json?t=' + Date.now());
    if (res.ok) {
      const data = await res.json();
      const currentVersion = process.env.VUE_APP_RC_VERSION;
      if (data.version && currentVersion && data.version !== currentVersion) {
        updateAvailable.value = true;
        return true;
      }
    }
  } catch (err) {
    console.error('Failed to check for version updates:', err);
  }
  return false;
};

const reloadPage = () => {
  const url = new URL(window.location.href);
  url.searchParams.set('t', Date.now().toString());
  window.location.href = url.toString();
};

router.afterEach(() => {
  const now = Date.now();
  if (now - lastCheckTime > 5 * 60 * 1000) {
    lastCheckTime = now;
    checkUpdate();
  }
});

onMounted(() => {
  // Clear the cache-busting query parameter from the URL if present
  const url = new URL(window.location.href);
  if (url.searchParams.has('t')) {
    url.searchParams.delete('t');
    window.history.replaceState({}, '', url.pathname + url.search + url.hash);
  }

  const savedTheme = localStorage.getItem('rc-theme');
  if (savedTheme === 'dark' || savedTheme === 'light') {
    theme.change(savedTheme);
  } else {
    theme.change('light');
  }

  // The header's Text size choice, kept per browser.
  useTextSize().applyTextSize();

  // Initial check on load
  checkUpdate();

  // Poll for updates every 15 minutes
  updateInterval = setInterval(checkUpdate, 15 * 60 * 1000);
});

onUnmounted(() => {
  if (updateInterval) {
    clearInterval(updateInterval);
  }
});
</script>